import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class ContainerFormBaseComponent {
  containerForm: FormGroup;
  errorMessage: string | null = null;

  constructor(protected fb: FormBuilder) {
    this.containerForm = this.fb.group({
      codOxy: ['', Validators.required],
      codRed: ['', Validators.required],
      typeContainerId: ['', Validators.required],
      nroSerie: ['', Validators.required],
      clientId: ['', Validators.required],
      containerOwnerId: ['', Validators.required],
      dateFabrication: ['', Validators.required],
      dateHydraulicTest: ['', Validators.required],
      tara: ['', Validators.required],

    });
  }

  markAllFieldsAsTouched() {
    Object.keys(this.containerForm.controls).forEach(field => {
      const control = this.containerForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get codOxy() {
    return this.containerForm.get('codOxy');
  }
  get codRed() {
    return this.containerForm.get('codRed');
  }
  get typeContainerId() {
    return this.containerForm.get('typeContainerId');
  }
  get nroSerie() {
    return this.containerForm.get('nroSerie');
  }
  get clientId() {
    return this.containerForm.get('clientId');
  }
  get dateFabrication() {
    return this.containerForm.get('dateFabrication');
  }
  get dateHydraulicTest() {
    return this.containerForm.get('dateHydraulicTest');
  }
  get tara() {
    return this.containerForm.get('tara');
  }
}
